import type { HotelPolicy } from "@/lib/gql/__generated__/graphql";

import { useCheckInAndCheckOut } from "@/components/features/_hooks/use-check-in-and-check-out/use-check-in-and-check-out";
import type { ForNodeType } from "@/components/features/_model/types/auto-generator-for-view-model";

import { useProductPlanFormModelContext } from "../../../../context";

export type UsePlanCheckInAndCheckOutProps = {
	hotelPolicy: Pick<HotelPolicy, "checkInStart" | "checkInEnd" | "checkOut" | "hotelInfo">;
};

export const usePlanCheckInAndCheckOut = () => {
	const { viewModel, onSetViewModel, queryData } = useProductPlanFormModelContext();
	const { hotelPolicy } = queryData;

	const { checkInStart: planCheckInStart, checkInEnd: planCheckInEnd, checkOut: planCheckOut } = viewModel;

	// プランのチェックイン・チェックアウト時間の初期値はホテルポリシーの値を使う
	const checkInStart: ForNodeType<string | null | undefined> = planCheckInStart?.value
		? planCheckInStart
		: ({
				isEdited: false,
				value: hotelPolicy.checkInStart,
			} satisfies ForNodeType<string>);

	const checkInEnd: ForNodeType<string | null | undefined> = planCheckInEnd?.value
		? planCheckInEnd
		: ({
				isEdited: false,
				value: hotelPolicy.checkInEnd,
			} satisfies ForNodeType<string>);

	const checkOut: ForNodeType<string | null | undefined> = planCheckOut?.value
		? planCheckOut
		: ({
				isEdited: false,
				value: hotelPolicy.checkOut,
			} satisfies ForNodeType<string>);

	return useCheckInAndCheckOut({
		checkInStart,
		checkInEnd,
		checkOut,
		onSetViewModel,
	});
};
